/* PerfumeOffs: open header dropdown menus on hover (desktop only) */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');

  function bind() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      var details = menu.querySelector('details');
      if (!details || details.dataset.poHover) return;
      details.dataset.poHover = '1';
      var summary = details.querySelector('summary');
      var closeTimer;

      function open() {
        clearTimeout(closeTimer);
        if (details.hasAttribute('open')) return;
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }

      function close() {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }

      menu.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        open();
      });

      menu.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        closeTimer = setTimeout(close, 150);
      });
    });
  }

  if (document.readyState !== 'loading') {
    bind();
  } else {
    document.addEventListener('DOMContentLoaded', bind);
  }
})();
